import React from "react";
import "photoswipe/dist/photoswipe.css";

import { Gallery, Item } from "react-photoswipe-gallery";

const Result = ({ dataResult }) => {
    return (
        <>
            <Gallery>
                <div>
                    {Array.isArray(dataResult) &&
                        dataResult.map((item, index) => {
                            return index === 0 ? (
                                <Item
                                    key={index}
                                    original={item}
                                    thumbnail={item}
                                    width="1200"
                                    height="1600"
                                    alt="Photo of seashore by Folkert 1"
                                >
                                    {({ ref, open }) => (
                                        <a
                                            href="/#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                open(e);
                                            }}
                                            ref={ref}
                                        >
                                            Kết quả
                                        </a>
                                    )}
                                </Item>
                            ) : (
                                <Item
                                    key={index}
                                    original={item}
                                    thumbnail={item}
                                    width="1200"
                                    height="1600"
                                    alt="Photo of seashore by Folkert 1"
                                >
                                    {({ ref, open }) => <span ref={ref}></span>}
                                </Item>
                            );
                        })}
                </div>
            </Gallery>
        </>
    );
};

export default Result;
